import React, { useRef } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";

const FilterMenu = ({ items }) => {
  const menu = useRef(null);
  return (
    <>
      <Button
        icon="pi pi-filter"
        className="p-button-rounded p-button-text p-button-secondary"
        onClick={(e) => menu.current.toggle(e)}
      />
      <Menu model={items} popup ref={menu} />
    </>
  );
};

export default FilterMenu;
